import React from "react";
import { Checkbox, FormControlLabel, Box } from "@mui/material";

import { useAdminProviderDataContext, useSearchCustomersContext } from "../../../../context";

const MainFilters: React.FC = () => {
  const {
    user: { allowed_features },
  } = useAdminProviderDataContext();

  const {
    isShowActiveSubscription,
    isShowLeads,
    setIsShowActiveSubscription,
    setIsShowLeads,
    isShowInactiveAccounts,
    setShowInactiveAccounts,
    isShowPassedEvaluations,
    setIsShowPassedEvaluations,
    isShowBanned,
    setIsShowBanned,
    isShowAbandoned,
    setIsShowAbandoned,
  } = useSearchCustomersContext();

  return (
    <Box gridTemplateColumns="1fr 1fr 1fr" display="grid" mt="9px">
      {allowed_features.show_inactive_accounts && (
        <FormControlLabel
          control={
            <Checkbox
              checked={isShowInactiveAccounts}
              onChange={() => setShowInactiveAccounts(!isShowInactiveAccounts)}
              name="inactiveAccounts"
            />
          }
          label="Show inactive accounts"
        />
      )}

      <FormControlLabel
        control={
          <Checkbox
            checked={isShowActiveSubscription}
            onChange={() => setIsShowActiveSubscription(!isShowActiveSubscription)}
            name="activeSubscription"
          />
        }
        label="Show active subscription"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={isShowLeads}
            onChange={() => setIsShowLeads(!isShowLeads)}
            name="leads"
          />
        }
        label="Show Leads"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={isShowPassedEvaluations}
            onChange={() => setIsShowPassedEvaluations(!isShowPassedEvaluations)}
            name="passed_evaluations"
          />
        }
        label="Show passed evaluations"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={isShowBanned}
            onChange={() => setIsShowBanned(!isShowBanned)}
            name="banned"
          />
        }
        label="Show banned accounts"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={isShowAbandoned}
            onChange={() => setIsShowAbandoned(!isShowAbandoned)}
            name="abandoned"
          />
        }
        label="Show abandoned accounts"
      />
    </Box>
  );
};

export default MainFilters;
